import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AccountStatementClientsRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/admin/account-statement?type=receivable', { replace: true });
  }, [navigate]);

  return null;
}
